// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Guidelines_container__ysGd4{
    margin: 50px 20px;
}
.Guidelines_subheader__xDREi{
    margin-bottom: 10px;
    font-weight: 700;
}
.Guidelines_paragraph__5U7cf{
    margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Guidelines.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".container{\n    margin: 50px 20px;\n}\n.subheader{\n    margin-bottom: 10px;\n    font-weight: 700;\n}\n.paragraph{\n    margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Guidelines_container__ysGd4`,
	"subheader": `Guidelines_subheader__xDREi`,
	"paragraph": `Guidelines_paragraph__5U7cf`
};
export default ___CSS_LOADER_EXPORT___;
